import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

function ETypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // console.log('vocabList E:', vocaList);
  return (
    <div
      style={{
        width: '100%',
        marginTop: `${config?.spacing * Spacing_Base}px`,
      }}
    >
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: '700',
            fontFamily: "'Pretendard', Arial, sans-serif",
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions?.map((voca, idx) => {
          return (
            <div
              key={`${voca.questions}-${String(idx)}`}
              style={{
                marginTop: `${config?.spacing * Spacing_Base}px`,
                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                display: 'grid',
                gridTemplateColumns: '1.2fr 8.8fr',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '5px',
                fontFamily: "'Pretendard', Arial, sans-serif",
                width: '100%',
              }}
            >
              <div
                style={{
                  flexShrink: 0,
                  minWidth: '10px',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                }}
              >
                {startNo + idx}.
              </div>
              {(tab === PAPER_TABS.TEST_PAPER ||
                tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                <div>
                  <div
                    style={{
                      fontFamily: "'Pretendard', Arial, sans-serif",
                      marginBottom: '5px',
                    }}
                  >
                    {strParse(voca.question)}
                  </div>
                  <div>
                    {voca.deriveds.map(word => {
                      return (
                        <div
                          key={`${word.question}-${String(idx)}`}
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            minHeight: '18px',
                            paddingTop: '3px',
                            flexWrap: 'nowrap',
                            gap: '5px',
                            marginBottom: '3px',
                            fontFamily: "'Pretendard', Arial, sans-serif",
                            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                          }}
                        >
                          <div style={{ minHeight: '18px', paddingTop: '5px' }}>
                            -&nbsp;
                          </div>
                          <div
                            style={{
                              fontFamily: "'Pretendard', Arial, sans-serif",
                              borderBottom: '1px solid #000',
                              minWidth: '100px',
                              minHeight: '18px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'flex-end',
                              paddingBottom: '3px',
                            }}
                          >
                            {tab === PAPER_TABS.TEST_PAPER && ''}
                            {tab === PAPER_TABS.TEST_PAPER &&
                              config?.vocaFirstWordShow && (
                                <div
                                  style={{
                                    width: '100%',
                                    minHeight: '18px',
                                    paddingTop: '3px',
                                    textAlign: 'left',
                                  }}
                                >
                                  {word?.answer[0]}
                                </div>
                              )}
                            {tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                              word.answer}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              minHeight: '18px',
                              paddingTop: '5px',
                              fontFamily: "'Pretendard', Arial, sans-serif",
                            }}
                          >
                            {word.question}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {tab === PAPER_TABS.ANSWER &&
                  voca?.deriveds?.map((word, idx) => {
                    return (
                      <div key={`${word.type}-${String(idx)}`}>
                        {word?.answer}
                        <span>
                          {idx !== voca?.deriveds?.length - 1 && `,`}&nbsp;
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ETypeTestRow.propTypes = {
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
};

export default ETypeTestRow;
